import { FC } from 'react';
import { Flex } from '@chakra-ui/react';

import Text from 'components/_core/Text';

import locales from './locales';
import { UploadMessageProps } from './types';

const UploadMessage: FC<UploadMessageProps> = ({
  dragAndDropMessage,
  helpText = locales.browseToChoose,
  imageElement,
}) => (
  <Flex alignItems="center" flexDirection="column">
    {imageElement}

    <Text
      fontWeight="weight-500"
      marginBottom="space-8"
      marginTop="space-16"
      size="lg"
      textAlign="center"
      variant="primary"
    >
      {dragAndDropMessage}
    </Text>

    <Text variant="light">{helpText}</Text>
  </Flex>
);

export default UploadMessage;
